if (!customElements.get('dut-category-scroll')) {
  customElements.define('dut-category-scroll', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dut-catalog-browse__links');
      this.prev = this.querySelector('.dut-catalog-browse__arrow--prev');
      this.next = this.querySelector('.dut-catalog-browse__arrow--next');
      this.update = () => {
        // Compare against the full container so reserved arrow space cannot cause false overflow.
        const overflow = this.track.scrollWidth > this.clientWidth + 1;
        this.toggleAttribute('data-overflow', overflow);
        this.prev.hidden = this.next.hidden = !overflow;
        this.prev.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      };
      this.move = event => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        this.track.scrollBy({left: (button === this.prev ? -1 : 1) * this.track.clientWidth * 0.75,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.addEventListener('click', this.move);
      this.track.addEventListener('scroll', this.update, {passive: true});
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this);
      this.resize.observe(this.track);
      this.update();
      document.fonts.ready.then(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      this.removeEventListener('click', this.move);
      this.track?.removeEventListener('scroll', this.update);
    }
  });
}
